import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RegistrationType, SignupFormData } from "../model/signup-types";
import { SignupRegistrationType } from "./SignupRegistrationType";
import { SignupForm } from "./SignupForm";
import { SignupComplete } from "./SignupComplete";
import { useSignup } from "../hooks/useSignup";

type SignupStep = "type" | "form" | "complete";

/**
 * SignupFlow - 다단계 회원가입 프로세스 관리
 * features 레이어에서 전체 흐름과 상태를 관리합니다
 */
export function SignupFlow() {
  const navigate = useNavigate();
  const { signup, isLoading } = useSignup();
  const [step, setStep] = useState<SignupStep>("type");
  const [selectedType, setSelectedType] = useState<RegistrationType | null>(
    null
  );
  const [formData, setFormData] = useState<SignupFormData | null>(null);

  const handleTypeSelect = (type: RegistrationType) => {
    setSelectedType(type);
    setStep("form");
  };

  const handleFormSubmit = async (data: SignupFormData) => {
    console.log("Signup data:", data);
    // return;
    setFormData(data);

    const result = await signup(data);
    console.log("Signup result:", result);
    // return;

    if (result.success) {
      // 회원가입 완료 페이지로 이동
      setStep("complete");
    }
  };

  const handleVerificationComplete = () => {
    // 제거됨
  };

  const handleBackToType = () => {
    setStep("type");
    setSelectedType(null);
  };

  const handleBackToForm = () => {
    setStep("form");
  };

  return (
    <div className="flex-1 flex items-center justify-center p-4 py-12">
      {step === "type" && <SignupRegistrationType onNext={handleTypeSelect} />}

      {step === "form" && selectedType && (
        <SignupForm
          type={selectedType}
          onSubmit={handleFormSubmit}
          onBack={handleBackToType}
          isLoading={isLoading}
        />
      )}

      {/* {step === "verification" && formData && (
        <EmailVerification
          email={formData.email}
          onVerified={handleVerificationComplete}
          onBack={handleBackToForm}
        />
      )} */}

      {step === "complete" && <SignupComplete />}
    </div>
  );
}
